// import React from 'react'
// import CompanyLogo from '../../assets/Images/companyDefault.png'

// const InterviewDetails = ({interviewData}) => {
//   return (
//     <div>
//         <h1 className='font-semibold text-xl mb-5'>Interview Details</h1>
//         <img className='w-10 h-10' src={interviewData?.avatar || CompanyLogo} alt="" />
//         <div className='mt-2 flex items-start justify-between'>
//             <div className='w-1/2'>
//                 <h1 className='font-semibold text-md'>Interview Type</h1>
//                 <p className='text-neutral-600'>{interviewData?.typeOfInterview}</p>
//             </div>

//             <div className='w-1/2'>
//                 <h1 className='font-semibold text-md'>Interview Location</h1>
//                 <p className='text-neutral-600'>{interviewData?.interviewLocation}</p>
//             </div>
//         </div>


//         <div className='mt-5 flex items-start justify-between'>
//             <div className='w-1/2'>
//                 <h1 className='font-semibold text-md'>Interview Date</h1>
//                 <p className='text-neutral-600'>{interviewData?.interviewDate}</p>
//             </div>

//             <div className='w-1/2'>
//                 <h1 className='font-semibold text-md'>Interview Time</h1>
//                 <p className='text-neutral-600'>{interviewData?.interviewTime}</p>
//             </div>
//         </div>

//         <div className='mt-8'>
//             <h1 className='font-semibold text-md'>Additional Information</h1>
//             <p className='text-neutral-600'>{interviewData?.additionalInformation}</p>
//         </div>
        
//     </div>
//   )
// }

// export default InterviewDetails
































// src/component/InterviewDetails.js
import React from "react";

const InterviewDetails = ({ interviewData }) => {
  if (!interviewData) {
    return (
      <div className="p-6">
        <p className="text-gray-600">No interview details available.</p>
      </div>
    );
  }

  return (
    <div className="p-6 bg-white rounded-lg">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Interview Details</h2>
      <div className="space-y-4">
        <div>
          <p className="font-medium text-gray-700">Job Title:</p>
          <p className="text-gray-600">{interviewData.application?.job?.jobTitle || "Waiter"}</p>
        </div>
        <div>
          <p className="font-medium text-gray-700">Company:</p>
          <p className="text-gray-600">{interviewData.application?.companyId?.name || "Essential"}</p>
        </div>
        <div>
          <p className="font-medium text-gray-700">Interview Type:</p>
          <p className="text-gray-600">{interviewData.typeOfInterview || "Virtual"}</p>
        </div>
        <div>
          <p className="font-medium text-gray-700">Date:</p>
          <p className="text-gray-600">
            {interviewData.interviewDate
              ? new Date(interviewData.interviewDate).toLocaleDateString()
              : "01-05-2025"}
          </p>
        </div>
        <div>
          <p className="font-medium text-gray-700">Time:</p>
          <p className="text-gray-600">{interviewData.interviewTime || "09:00am"}</p>
        </div>
        {interviewData.interviewLocation && interviewData.interviewLocation !== "none" && (
          <div>
            <p className="font-medium text-gray-700">Location:</p>
            <p className="text-gray-600">{interviewData.interviewLocation}</p>
          </div>
        )}
        <div>
          <p className="font-medium text-gray-700">Additional Information:</p>
          <p className="text-gray-600">{interviewData.additionalInformation || "N/A"}</p>
        </div>
        <div>
          <p className="font-medium text-gray-700">Status:</p>
          <p className="text-gray-600 capitalize">{interviewData.status || "9:00am"}</p>
        </div>
        {interviewData.questions?.length > 0 && (
          <div>
            <p className="font-medium text-gray-700 mb-2">Questions:</p>
            <ul className="space-y-2 text-gray-600">
              {interviewData.questions.map((q, index) => (
                <li key={index} className="bg-gray-50 p-3 rounded-md">
                  <p className="font-medium">{q.question}</p>
                  {q.response && (
                    <p className="text-sm mt-1">Response: {q.response}</p>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default InterviewDetails;